import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import { SurveySessionValueModel } from '@trialcard/apigateway.models';
import SurveyModule from './survey';
import SessionModule from './session';
import { Settings } from '~/services/settings';
import { EligibilityQuestions, correctAnswers } from '~/types/eligibility';

@InjectModule({ stateFactory: true }, module)
export default class EligibilityModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    @Resolve
    public survey!: SurveyModule;

    @Resolve
    public session!: SessionModule;

    public sppEligibilityData: EligibilityQuestions = {};
    public hubEligibilityData: EligibilityQuestions = {};

    public isEligible = false;

    @Mutation
    public async updateSppEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.sppEligibilityData) {
        this.sppEligibilityData = { ...this.sppEligibilityData, ...newEligibilityData };
    }
    @Mutation
    public async updateHubEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.hubEligibilityData) {
        this.hubEligibilityData = newEligibilityData;
    }

    @Mutation
    public async updateIsEligible(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    @Action({ rawError: true })
    public checkSppEligibility(): boolean {
        const correctAnswers: correctAnswers = {
            patientConsent: +this.settings.patientConsentAnswer,
            isUSResident: +this.settings.isUSResidentAnswer,
            isSixteenOrOlder: +this.settings.isSixteenOrOlderAnswer,
            hasInsurance: +this.settings.hasInsuranceAnswer,
            notPayingCash: +this.settings.notPayingCashAnswer,
            coversCostPartially: +this.settings.coversCostPartiallyAnswer,
            coversCostFully: +this.settings.coversCostFullyAnswer,
            notEnrolled: +this.settings.notEnrolledAnswer,
            hasPrescription: +this.settings.hasPrescriptionAnswer,
            hasDiscussed: +this.settings.hasDiscussedAnswer,
        };
        this.survey.setSurveyId(this.settings.surveyId);
        this.survey.setCardTypeQuestionId(this.settings.cardTypeQuestionId);
        this.survey.setCardTypeAnswerId(this.settings.cardTypeAnswerId);

        const isEligible = Object.entries(this.sppEligibilityData).every(
            ([prop, obj]: [keyof correctAnswers, SurveySessionValueModel]) => correctAnswers[prop] === obj.answerId
        );
        this.updateIsEligible(isEligible);
        return isEligible;
    }

    // @Action({ rawError: true })
    // public checkHubEligibility(): boolean {
    //     const correctAnswers = [
    //         +this.settings.hubAnswerId1Yes,
    //         +this.settings.hubAnswerId2Yes,
    //         +this.settings.hubAnswerId3No,
    //         +this.settings.hubAnswerId4Yes,
    //         +this.settings.hubAnswerId5No,
    //         +this.settings.hubAnswerId6Yes,
    //         +this.settings.hubAnswerId7Yes,
    //     ];
    //     this.survey.setSurveyId(this.settings.hubSurveyId);
    //     this.survey.setCardTypeQuestionId(this.settings.hubCardTypeQuestionId);
    //     this.survey.setCardTypeAnswerId(this.settings.hubCardTypeAnswerId);

    //     const isEligible = this.hubEligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
    //     this.updateIsEligible(isEligible);
    //     return isEligible;
    // }
}
